var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 18.23,
    viewBox: "0 0 19.5 18.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4171"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3364"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3416"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeWidth: 2,
    "data-name": "Group 3198"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3197"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.00104,
    d: "M5.75 1.41v14.11",
    "data-name": "Line 40"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.00104,
    d: "M5.76 1.41 1.4 5.76",
    "data-name": "Line 41"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3196"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.00104,
    d: "M13.75 16.82V2.72",
    "data-name": "Line 40"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.00104,
    d: "m13.75 16.82 4.34-4.34",
    "data-name": "Line 41"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.18a998a6e11fba612a48091e163a745f.svg";
export { ForwardRef as ReactComponent };